import { queryOptions } from '@tanstack/react-query';
import { getCleaningMissionQuery } from './get-cleaning-mission-query';

export const getCleaningMissionQueryOptions = (id: string) =>
  queryOptions({
    queryKey: [getCleaningMissionQuery(id).className, getCleaningMissionQuery(id).toJSON()],
    queryFn: () => getCleaningMissionQuery(id).find(),
    refetchOnWindowFocus: 'always',
    refetchOnReconnect: 'always',
  });
